import { ContractChangesSection } from './types'

export const resolveContractChangesSection = (
  isContractPartyMoveOut: boolean
) =>
  isContractPartyMoveOut
    ? ContractChangesSection.TERMINATE_CONTRACT
    : ContractChangesSection.RESIDENT_CHANGES
